import React from 'react'
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import { useTranslation } from 'react-i18next';
import IconButton from '../../IconButton/IconButton';
import { ReactComponent as DeleteIcon } from '../../../assets/icons/trash.svg';

const SoftwareCertificates = ({ parentState, onCertificateDelete, children }) => {
    const { t } = useTranslation();
    const certsNotAvailable = <p>{t('certificates.certificate-not-available')}</p>;
    const {
        certificatesOrdered: { Software }
    } = parentState;

    if (Software.length === 0) {
        Software.push({
            GUID: 'placeholder',
            certalias: '---',
            ExpirationDate: '---',
        })
    }

    const softwareColumns = [
        {
            dataField: 'certalias',
            text: t('certificates.certificate'),
            align: 'left',
            sort: true,
            headerAlign: 'left',
            headerClasses: 'headerClass1',
            style: { verticalAlign: 'middle' }
        },
        {
            dataField: 'ExpirationDate',
            text: t('certificates.certificate-date'),
            align: 'left',
            sort: true,
            headerAlign: 'left',
            headerClasses: 'headerClass2',
            style: { verticalAlign: 'middle' }
        },
        {
            dataField: 'ActionButton',
            text: '',
            align: 'center',
            headerAlign: 'left',
            isDummyField: true,
            style: { verticalAlign: 'middle' },
            headerClasses: 'headerClass3',
            formatter: (cellContent, row) => {
                return row.certalias === "---" ? "---" : (
                    <div className='keyvault-buttons-container'>
                        <IconButton
                            icon={DeleteIcon}
                            tooltipText={t('certificates.certificate-delete')}
                            onClick={() => onCertificateDelete(row)}
                            />
                    </div>
                );
            }
        }
    ];

    return (
        <div className="table-container">
            <div className='table-container-header-align-right'>
                {children}
            </div>
            {Software.length === 0 &&
                certsNotAvailable
            }
            {Software.length > 0 &&
                <ToolkitProvider
                    keyField="GUID"
                    data={Software}
                    columns={softwareColumns}
                >
                    {
                        props => (
                            <div>
                                <BootstrapTable striped
                                    {...props.baseProps}
                                />
                            </div>
                        )
                    }
                </ToolkitProvider>
            }
        </div>
    )
}

export default SoftwareCertificates